<template>
  <div id="ActivityQnA">
      <h5>
          활동 문의
      </h5>
      <hr>

      <div class="row">
        <div class="col-3">
          <img :src="!$auth.user().profileImage ? require('@/assets/img/profile_base.png') : $auth.user().profileImage" class="img-profile rounded-circle " alt=""><br/>
          <span class="profile-text" v-if="$auth.check()">Lv.{{ $root.$children[0].getLevelByMinute($auth.user().volunteerMinute).level }} {{$auth.user().name}}</span>
        </div>
        <div class="col input-group">
          <textarea placeholder="질문을 남겨주세요." class="form-control custom-control" rows="3" style="resize:none" ref="replyContents" v-model="reply.replyContents"></textarea>
          <span class="input-group-addon btn btn-primary" v-on:click="formSubmit()">작성</span>
        </div>
      </div>

      <hr/>

    <ActivityReplyAnswer :reply="reply" :replyList="replyList" :isRichContent="true" :replyType="reply.replyType" :isEditor="false" answerAuth="ADMIN"></ActivityReplyAnswer>
    <button type="button" class="btn-white btn btn-block" @click="getMore()" v-if="page.pageSize == currentLength">더보기</button>
    <h4 v-if="replyList.length==0" class="text-center">
      등록된 문의가 없습니다.
    </h4>
  </div>


</template>

<script>
import VueMomentsAgo from 'vue-moments-ago'
import ActivityReplyAnswer from "../../components/activity/ActivityReplyAnswer";

export default {
    name: 'ActivityQnA',
    components: { VueMomentsAgo, ActivityReplyAnswer},
    data() {
        return {

            reply: {
                id:0,
                replyContents: "",
                activityId: 0,
                memberId: 0,
                replyType: 'QUESTION',
                MemberIsWithdraw: false,
            },
            replyList: [],
            page:{
                pageNum:0,
                pageSize:5,
            },
            answer : {
              replyContents:'',
              parentId: 0,
              memberId: 0,
              activityId: 0,
              replyType: 'QUESTION',
              MemberIsWithdraw: false,
            },
            currentLength: 0,
        };
    },

    methods: {
        popupLogin() {
          this.$modal.show('dialog', {
            title: '회원 전용',
            text: '로그인이 필요합니다.',
            buttons: [
              {
                title: '로그인 하기',
                handler: () => {
                  this.$router.push({ name: 'login', params: { ref: this.$router.currentRoute.path }});
                  this.$modal.hide('dialog');
                }

              },
              {
                title: '닫기'
              }
            ]
          })
        },
        formSubmit() {
            if (this.reply.replyContents == '') {
                this.$root.$children[0].commonDialog('댓글등록','내용을 입력하세요.');
                //this.$refs.replyContents.focus();
                return;
            }
            if(!this.$auth.check()) {
                this.popupLogin();
                return;
            } else {
                this.reply.memberId = this.$auth.user().id;
            }

            let me = this;
            this.reply.id = 0;
            this.axios.post(process.env.VUE_APP_ACTIVITY_API_URL + '/reply', this.reply)
              .then(function (res) {
                  me.$root.$children[0].commonDialog('댓글등록','등록 되었습니다.');
                  me.getList();
                  me.reply.replyContents = "";
              }).catch(function (error) {
                console.log(error);
            });
        },

        getList() {
            let me = this;
            this.axios.get(process.env.VUE_APP_ACTIVITY_API_URL +
                `/reply/list?activityId=${this.reply.activityId}&replyType=${this.reply.replyType}&page=${this.page.pageNum}&size=${this.page.pageSize}`)
                .then(function (res) {
                    me.currentLength = res.data.length;
                    me.replyList=res.data;
                }).catch(function (error) {
                console.log(error);
            });
        },

        answerReply: function(reply) {
            if(this.answer.parentId != reply.id)
              this.answer.parentId = reply.id;
            else {
                this.answer.memberId = this.$auth.user().id;
                this.answer.replyType = reply.replyType;
                this.answer.activityId = reply.activityId;

                let me = this;
                this.axios.post(process.env.VUE_APP_ACTIVITY_API_URL + '/reply', this.answer)
                    .then(function (res) {
                        me.$root.$children[0].commonDialog('대댓글등록', '답변이 등록 되었습니다.');
                        me.answer.replyContents = "";
                        me.answer.parentId = 0;
                        me.getList();
                    }).catch(function (error) {
                    console.log(error);
                });
            }
        },
        getMore() {
          this.page.pageSize+=5;
          this.getList();
        }
    },
    mounted() {
        this.reply.activityId = this.$route.params.id;
        this.getList();
    }

}
</script>
